export default function Logo({ size = 40, withWordmark = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/brand/nanak-crest-512.png"
        alt="Nanak Chauffeurs crest"
        width={size}
        height={size}
        className="shrink-0 select-none"
        draggable={false}
        data-testid="brand-crest"
      />
      {withWordmark && (
        <span className="leading-none">
          <span className="block font-display text-xl font-semibold tracking-wide text-ivory">
            Nanak
          </span>
          <span className="block font-mono text-[9px] uppercase tracking-[0.42em] text-gold mt-1">
            Chauffeurs
          </span>
        </span>
      )}
    </span>
  );
}

export function BrandLockup({ className = "", ...rest }) {
  return (
    <img
      src="/brand/nanak-logo.png"
      alt="Nanak Chauffeur's — crest with lions and crown"
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
